import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AuthLoading } from 'src/features/auth/contexts/AuthLoading';
import { ReactChildren } from 'src/shared/types/util.types';

export function SmartRedirect({ children }: ReactChildren) {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: '/', search: Object.fromEntries(new URLSearchParams(window.location.search)) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isLoading]);

  if (isLoading || isAuthenticated) {
    return <AuthLoading text="Logging in" delay={10} from={0} to={0} />;
  }

  return children;
}
